import { Box } from "@chakra-ui/react";
import type { CategoryListProps } from "./CategoryList.d";
import CategoryListItem from "../CategoryListItem";

const CategoryList = ({ categories }: CategoryListProps) => (
  <Box>
    {categories.map((category, index) => (
      <CategoryListItem key={category.id} category={category} isLast={index + 1 === categories.length} />
    ))}
  </Box>
);

export default CategoryList;
